var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCurrentLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,12c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5,1.12-2.5,2.5-2.5,2.5,1.12,2.5,2.5Zm5.5,1h-1.08c-.44,3.06-2.86,5.48-5.92,5.92v1.08h-2v-1.08c-3.06-.44-5.48-2.86-5.92-5.92h-1.08v-2h1.08c.44-3.06,2.86-5.48,5.92-5.92v-1.08h2v1.08c3.06,.44,5.48,2.86,5.92,5.92h1.08v2Zm-3-1c0-2.76-2.24-5-5-5s-5,2.24-5,5,2.24,5,5,5,5-2.24,5-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCurrentLocation);
export default __webpack_public_path__ + "static/1776335122/media/icon-current-location.1d00fe36c2cc9a4a1113a69a11e3cdf6.svg";
export { ForwardRef as ReactComponent };